import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../types";



const getMmsSales = function(state:RootState) {
    return state.mmsSales;
  };

  export const getMmsSalesDetail = createSelector(getMmsSales,(mmsSales)=>mmsSales)
